export interface CgmParcel {
  name: string;
  areaHa: number;
  designFlowM3h: number;
}

export interface CgmSector {
  code: string;
  areaHa: number;
  designFlowM3h: number;
  parcels: CgmParcel[];
}

export interface CgmSite {
  name: string;
  waterSource: string;
  capacityM3h: number | null;
  areaHa: number;
  sectors: CgmSector[];
}

export interface CgmTopology {
  clientName: string;
  organizationId: string;
  farmId: string;
  irrigationType: string;
  summary: {
    areaHa: number;
    siteCount: number;
    sectorCount: number;
    parcelCount: number;
  };
  sites: CgmSite[];
  capabilities: {
    dripIrrigation: boolean;
    sectors: boolean;
    equipment: boolean;
    valveControl: boolean;
    pumping: boolean;
    filtration: boolean;
    greenhouses: boolean;
    pivots: boolean;
  };
  livePilot: {
    soilNodeId: string;
    valveNodeId: string;
    pressureModel: string;
  };
}

export const CGM_PILOT_ORG_ID = 'org-cgm';

export const isCgmPilotOrg = (orgId: string | undefined | null): boolean =>
  typeof orgId === 'string' && orgId.trim() === CGM_PILOT_ORG_ID;

/**
 * Shared predicate for the CGM farmer experience (dashboard / sectors /
 * pilotage / drip navigation). The backend client-topology already refuses
 * platform superadmins, so a platform superadmin — even one carrying
 * org_id === org-cgm — must receive the PLATFORM standard experience, never
 * the CGM farmer routes. Every other CGM-org role keeps its current behavior.
 */
export const isCgmPilotExperience = (
  orgId: string | undefined | null,
  role: string | undefined | null,
): boolean => {
  if (!isCgmPilotOrg(orgId)) return false;
  return typeof role === 'string' && role.trim().length > 0 && role.trim().toLowerCase() !== 'superadmin';
};

/**
 * null  -> source capacity not documented
 * true  -> sector design flow exceeds documented source capacity
 * false -> sector design flow is within documented source capacity
 */
export const isCgmSectorOverCapacity = (site: CgmSite, sector: CgmSector): boolean | null => {
  if (site.capacityM3h === null) return null;
  return sector.designFlowM3h > site.capacityM3h;
};
